/******/ (() => {
  'use strict';

  // Selector for focusable descendants per HTML spec — used as
  // fallback when `inert` is not honored by the browser.
  var FOCUSABLE_SELECTOR = [
    'a[href]',
    'area[href]',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'button:not([disabled])',
    'iframe',
    'object',
    'embed',
    '[contenteditable]',
    '[tabindex]:not([tabindex^="-"])'
  ].join(',');

  // Test for native inert support once at load.
  var SUPPORTS_INERT = 'inert' in HTMLElement.prototype;

  function setCellInert($cell, makeInert) {
    var cell = $cell[0];
    if (!cell) return;

    if (SUPPORTS_INERT) {
      if (makeInert) {
        cell.setAttribute('inert', '');
      } else {
        cell.removeAttribute('inert');
      }
    }

    // Always apply the tabindex fallback as defense-in-depth.
    // Stash original tabindex on first pass; restore when re-shown.
    var focusables = cell.querySelectorAll(FOCUSABLE_SELECTOR);
    focusables.forEach(function (el) {
      if (makeInert) {
        if (!el.hasAttribute('data-a11y-prev-tabindex')) {
          el.setAttribute(
            'data-a11y-prev-tabindex',
            el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : ''
          );
        }
        el.setAttribute('tabindex', '-1');
      } else {
        if (el.hasAttribute('data-a11y-prev-tabindex')) {
          var prev = el.getAttribute('data-a11y-prev-tabindex');
          if (prev === '') {
            el.removeAttribute('tabindex');
          } else {
            el.setAttribute('tabindex', prev);
          }
          el.removeAttribute('data-a11y-prev-tabindex');
        }
      }
    });
  }

  function updateCarousel($carousel) {
    var flkty = $carousel.data('flickity');
    if (!flkty || !flkty.cells) return;

    var selectedElements = flkty.selectedElements || [];
    flkty.cells.forEach(function (cell) {
      var isSelected = selectedElements.indexOf(cell.element) !== -1;
      setCellInert($(cell.element), !isSelected);
    });
  }

  // Delegated listeners — fire after Flickity's own select/settle.
  $(document).on('select.flickity settle.flickity', '.flickity-enabled', function () {
    updateCarousel($(this));
  });

  // Initial pass for carousels already initialized when this script loads.
  // Also catches carousels initialized after DOMContentLoaded (e.g., via
  // dynamic section reload in theme editor) — MutationObserver watches
  // for the .flickity-enabled class being added.
  function initialPass() {
    $('.flickity-enabled').each(function () {
      updateCarousel($(this));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialPass);
  } else {
    initialPass();
  }

  // Watch for new Flickity instances (theme editor reloads, AJAX-loaded
  // sections like product recommendations, Searchspring re-renders).
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          var el = m.target;
          if (el.classList && el.classList.contains('flickity-enabled')) {
            // Debounce — Flickity sets the class before cells are
            // populated; wait one tick.
            setTimeout(function () { updateCarousel($(el)); }, 0);
          }
        }
      });
    });
    observer.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // Expose for debugging.
  window.PXUTheme = window.PXUTheme || {};
  window.PXUTheme.a11yFlickityFocus = { update: updateCarousel };
/******/ })();
